import React from "react";
export const SignOutIcon = () => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.21403 22.0009C2.89385 22.0055 2.57614 21.9444 2.28049 21.8214C1.98484 21.6984 1.71752 21.5162 1.49502 21.2859C1.2647 21.0635 1.08243 20.7961 0.959456 20.5005C0.83648 20.2048 0.775415 19.8871 0.780028 19.5669V14.6979H3.21403V19.5669H20.255V2.52593H3.21403V7.39495H0.780028V2.52593C0.775534 2.20576 0.836655 1.8881 0.959624 1.59246C1.08259 1.29681 1.2648 1.02947 1.49502 0.806933C1.71756 0.576708 1.98489 0.394501 2.28053 0.271532C2.57617 0.148563 2.89386 0.0874112 3.21403 0.0919057H20.255C20.5752 0.0874112 20.8929 0.148563 21.1885 0.271532C21.4842 0.394501 21.7515 0.576708 21.974 0.806933C22.2043 1.02947 22.3865 1.29681 22.5094 1.59246C22.6324 1.8881 22.6935 2.20576 22.689 2.52593V19.5669C22.6936 19.8871 22.6326 20.2048 22.5096 20.5005C22.3866 20.7961 22.2043 21.0635 21.974 21.2859C21.7515 21.5162 21.4842 21.6984 21.1886 21.8214C20.8929 21.9444 20.5752 22.0055 20.255 22.0009H3.21403ZM9.90903 17.1319L8.20903 15.3669L11.309 12.267H0.780028V9.83196H11.309L8.20903 6.73192L9.90903 4.96691L15.995 11.0529L9.90903 17.1319Z"
        fill="#333333"
      />
    </svg>
  );
};

export const NoDataImage = () => {
  return (
    <svg width="345" height="287" viewBox="0 0 345 287" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3694_8732)">
        <g filter="url(#filter0_d_3694_8732)">
          <path
            d="M153.54 54.5382C153.473 54.5382 153.406 54.5358 153.339 54.5316C148.913 54.2473 133.77 52.1057 124.726 36.4726C124.058 35.3187 124.19 33.8504 125.055 32.8199C132.607 26.6791 138.507 20.033 141.989 12.6482C142.618 11.899 143.562 11.4895 144.517 11.5064C145.498 11.5295 146.401 11.9912 146.997 12.7729C151.29 18.4135 159.767 28.3988 168.297 31.8997C169.255 32.2936 169.949 33.0927 170.201 34.0937C170.45 35.0862 170.219 36.1094 169.567 36.9008L156.001 53.3699C155.391 54.1106 154.483 54.5382 153.54 54.5382Z"
            fill="#E6E6E6"
          />
          <path
            d="M127.854 33.8121C127.623 34.0879 127.581 34.4812 127.749 34.792C135.931 49.8536 150.558 51.0352 153.407 51.1189C153.682 51.1346 153.939 51.0111 154.113 50.7997L167.582 34.4493C167.773 34.2174 167.831 33.9217 167.744 33.6362C167.655 33.3496 167.438 33.1358 167.147 33.0515C157.999 30.3787 148.401 17.9989 145.677 14.2679C145.518 14.0499 145.272 13.9192 145.003 13.9102C144.726 13.9075 144.474 14.0162 144.297 14.2258C140.4 21.8228 134.943 28.3679 127.854 33.8121Z"
            fill="white"
          />
          <path
            d="M134.637 37.3389L146.846 24.8935C147.681 24.0427 146.373 22.7334 145.537 23.5853L133.328 36.0307C132.494 36.8814 133.801 38.1907 134.637 37.3389Z"
            fill="#E6E6E6"
          />
          <path
            d="M142.006 40.8469C145.375 37.8275 148.304 34.3315 150.701 30.4953C151.334 29.4827 149.734 28.5529 149.103 29.5615C146.785 33.2703 143.955 36.6199 140.697 39.5387C139.809 40.335 141.121 41.6399 142.006 40.8469Z"
            fill="#E6E6E6"
          />
          <path
            d="M148.648 45.0439C151.715 41.6463 154.327 37.8545 156.383 33.7643C156.916 32.7032 155.32 31.7653 154.785 32.8305C152.799 36.7824 150.304 40.4523 147.339 43.7356C146.543 44.6175 147.847 45.9299 148.648 45.0439Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter1_d_3694_8732)">
          <path
            d="M164.643 59.4718C164.576 59.4718 164.509 59.4694 164.442 59.4652C160.017 59.1809 144.874 57.0393 135.83 41.4062C135.162 40.2522 135.294 38.784 136.158 37.7535C143.334 31.5317 148.736 24.7282 153.093 17.5818C153.722 16.8326 154.666 16.4231 155.621 16.44C156.601 16.4631 157.505 16.9248 158.1 17.7065C162.394 23.3471 170.871 33.3324 179.4 36.8333C180.359 37.2272 181.053 38.0263 181.304 39.0273C181.554 40.0198 181.323 41.043 180.671 41.8344L167.105 58.3034C166.495 59.0442 165.586 59.4718 164.643 59.4718Z"
            fill="#E6E6E6"
          />
          <path
            d="M138.958 38.7457C138.727 39.0215 138.685 39.4148 138.853 39.7256C147.035 54.7872 161.662 55.9688 164.511 56.0525C164.785 56.0682 165.042 55.9447 165.216 55.7333L178.686 39.3829C178.876 39.151 178.935 38.8553 178.847 38.5698C178.759 38.2832 178.541 38.0694 178.25 37.9851C169.103 35.3123 159.505 22.9325 156.781 19.2015C156.621 18.9835 156.375 18.8528 156.106 18.8438C155.829 18.8411 155.577 18.9498 155.401 19.1594C150.732 26.9152 145.48 33.7903 138.958 38.7457Z"
            fill="white"
          />
          <path
            d="M145.74 42.2725L157.95 29.8271C158.784 28.9763 157.477 27.667 156.641 28.5188L144.432 40.9643C143.597 41.815 144.905 43.1243 145.74 42.2725Z"
            fill="#E6E6E6"
          />
          <path
            d="M153.109 45.7805C156.479 42.7611 159.407 39.265 161.805 35.4289C162.438 34.4163 160.837 33.4865 160.207 34.4951C157.889 38.2039 155.058 41.5535 151.801 44.4722C150.912 45.2686 152.224 46.5735 153.109 45.7805Z"
            fill="#E6E6E6"
          />
          <path
            d="M159.751 49.9775C162.819 46.5799 165.43 42.7881 167.486 38.6979C168.02 37.6368 166.424 36.6989 165.888 37.7641C163.902 41.716 161.407 45.3859 158.443 48.6692C157.646 49.5511 158.951 50.8635 159.751 49.9775Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter2_d_3694_8732)">
          <path
            d="M286.164 174.179C286.097 174.179 286.03 174.176 285.963 174.172C281.538 173.888 266.395 171.746 257.351 156.113C256.683 154.959 256.815 153.491 257.679 152.461L274.614 132.289C275.243 131.54 276.187 131.13 277.142 131.147C278.122 131.17 279.381 131.461 279.621 132.414C281.572 140.155 289.974 150.207 300.921 151.54C301.95 151.666 302.574 152.733 302.825 153.734C303.075 154.727 302.844 155.75 302.192 156.541L288.626 173.01C288.016 173.751 287.107 174.179 286.164 174.179Z"
            fill="#E6E6E6"
          />
          <path
            d="M260.479 153.453C260.248 153.729 260.206 154.122 260.374 154.433C268.556 169.494 283.183 170.676 286.032 170.76C286.306 170.775 286.563 170.652 286.737 170.44L300.207 154.09C300.397 153.858 300.456 153.562 300.368 153.277C300.28 152.99 300.074 152.706 299.771 152.692C288.127 152.146 278.775 139.557 278.302 133.909C278.279 133.64 277.896 133.56 277.627 133.551C277.35 133.548 277.098 133.657 276.922 133.866L260.479 153.453Z"
            fill="white"
          />
          <path
            d="M267.261 156.98L279.47 144.534C280.305 143.683 278.998 142.374 278.162 143.226L265.953 155.671C265.118 156.522 266.426 157.831 267.261 156.98Z"
            fill="#E6E6E6"
          />
          <path
            d="M274.63 160.487C278 157.468 280.928 153.972 283.326 150.136C283.959 149.123 282.358 148.194 281.728 149.202C279.41 152.911 276.579 156.261 273.322 159.179C272.433 159.976 273.745 161.28 274.63 160.487Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.272 164.684C284.34 161.287 286.951 157.495 289.007 153.405C289.541 152.344 287.945 151.406 287.409 152.471C285.423 156.423 282.928 160.093 279.964 163.376C279.167 164.258 280.472 165.571 281.272 164.684Z"
            fill="#E6E6E6"
          />
        </g>
        <path
          d="M311.53 276.311C312.804 276.391 313.509 274.808 312.544 273.885L312.449 273.504C312.461 273.474 312.474 273.443 312.487 273.413C313.775 270.34 318.143 270.362 319.421 273.438C320.555 276.169 321.999 278.905 322.355 281.792C322.514 283.067 322.442 284.365 322.159 285.616C324.817 279.812 326.215 273.475 326.215 267.102C326.215 265.501 326.128 263.9 325.948 262.302C325.801 260.996 325.598 259.697 325.335 258.411C323.913 251.456 320.833 244.832 316.39 239.299C314.255 238.132 312.474 236.308 311.398 234.121C311.012 233.333 310.709 232.484 310.565 231.62C310.808 231.652 311.482 227.951 311.299 227.724C311.637 227.21 312.243 226.955 312.613 226.454C314.453 223.96 316.988 224.395 318.311 227.784C321.137 229.21 321.165 231.576 319.43 233.85C318.327 235.298 318.175 237.256 317.207 238.805C317.307 238.933 317.41 239.056 317.51 239.184C319.336 241.526 320.916 244.043 322.248 246.688C321.872 243.749 322.427 240.208 323.375 237.925C324.453 235.324 326.474 233.134 328.254 230.886C330.392 228.185 334.777 229.363 335.153 232.787C335.157 232.82 335.16 232.853 335.164 232.886C334.9 233.036 334.641 233.194 334.388 233.361C332.944 234.315 333.443 236.552 335.153 236.816L335.192 236.822C335.096 237.774 334.933 238.718 334.694 239.646C336.977 248.475 332.047 251.69 325.008 251.835C324.853 251.914 324.701 251.994 324.546 252.07C325.259 254.077 325.829 256.136 326.251 258.224C326.63 260.068 326.893 261.932 327.04 263.804C327.223 266.166 327.207 268.54 327.008 270.898L327.02 270.814C327.526 268.217 328.937 265.792 330.985 264.111C334.035 261.605 338.345 260.683 341.637 258.669C343.221 257.699 345.251 258.952 344.975 260.788L344.961 260.876C344.471 261.076 343.993 261.307 343.531 261.565C343.266 261.715 343.007 261.873 342.754 262.04C341.311 262.995 341.81 265.231 343.52 265.495L343.559 265.501C343.587 265.505 343.61 265.509 343.638 265.513C342.798 267.508 341.626 269.361 340.16 270.958C338.732 278.665 332.6 279.396 326.04 277.152H326.036C325.319 280.275 324.271 283.326 322.924 286.233H311.809C311.769 286.11 311.733 285.982 311.697 285.859C312.725 285.923 313.761 285.863 314.773 285.676C313.948 284.664 313.123 283.644 312.299 282.633C312.279 282.613 312.263 282.593 312.247 282.573C311.828 282.055 311.406 281.541 310.988 281.023L310.988 281.023C310.961 279.433 311.152 277.849 311.53 276.311Z"
          fill="#F2F2F2"
        />
        <path
          d="M-19 286.5C-19 286.777 -18.4724 287 -17.8154 287H343.815C344.472 287 345 286.777 345 286.5C345 286.223 344.472 286 343.815 286H-17.8154C-18.4724 286 -19 286.223 -19 286.5Z"
          fill="#CCCCCC"
        />
        <g filter="url(#filter3_d_3694_8732)">
          <path d="M235.432 281.703L228.116 281.702L224.636 253.492L235.433 253.493L235.432 281.703Z" fill="#FFB6B6" />
          <path
            d="M210.368 281.537C210.14 281.92 210.02 283.158 210.02 283.604C210.02 284.975 211.132 286.086 212.503 286.086H235.158C236.093 286.086 236.852 285.328 236.852 284.393V283.45C236.852 283.45 237.972 280.616 235.665 277.123C235.665 277.123 232.797 279.858 228.512 275.574L227.248 273.285L218.101 279.973L213.031 280.597C211.922 280.734 210.939 280.576 210.368 281.537Z"
            fill="black"
          />
          <path d="M302.983 267.27L296.752 271.102L279.003 248.897L288.199 243.242L302.983 267.27Z" fill="#FFB6B6" />
          <path
            d="M281.549 280.257C281.556 280.703 282.102 281.821 282.336 282.2C283.055 283.368 284.584 283.732 285.752 283.014L305.048 271.146C305.845 270.656 306.093 269.613 305.603 268.817L305.109 268.014C305.109 268.014 304.578 265.013 300.782 263.246C300.782 263.246 299.773 267.078 293.878 265.674L291.602 264.387L287.316 274.875L283.325 278.062C282.452 278.759 281.531 279.14 281.549 280.257Z"
            fill="black"
          />
          <path
            d="M257.004 149.761C256.642 148.182 256.669 146.649 257.009 145.378L252.601 130.561L259.778 128.615L263.476 143.856C264.334 144.844 265.026 146.208 265.388 147.787C266.215 151.395 265.009 154.761 262.694 155.306C260.378 155.851 257.831 153.368 257.004 149.761Z"
            fill="#FFB6B6"
          />
          <path
            d="M216.17 50.9892C216.17 50.9892 227.736 45.9563 234.194 53.2292C240.072 59.8489 252.005 79.7687 250.779 81.7068L262.526 137.2L253.819 139.882L230.721 76.0517L216.17 50.9892Z"
            fill="#2F3A79"
          />
          <path
            d="M203.433 133.228L209.392 202.733L223.793 267.272L239.187 265.783L231.738 195.286L236.298 132.635L203.433 133.228Z"
            fill="black"
          />
          <path
            d="M204.665 148.309L241.781 207.381L284.13 258.176L297.135 249.808L258.241 190.535C252.288 164.426 245.695 140.257 233.614 132.744L204.665 148.309Z"
            fill="black"
          />
          <path
            d="M206.831 148.598C205.09 148.598 203.404 147.984 202.03 146.82C200.185 145.256 199.224 142.976 199.393 140.564L202.631 109.508L201.394 75.5954L201.402 75.5587L205.246 57.1299C205.284 56.5442 205.407 55.9242 205.605 55.3288L211.283 38.2629C212.304 35.1933 215.163 33.1309 218.399 33.1309H223.42C225.934 33.1309 228.267 34.379 229.661 36.47L234.056 43.061C234.348 43.4989 234.594 43.9689 234.788 44.4582L244.491 68.9405C244.799 69.7177 244.974 70.5353 245.012 71.3703L248.022 139.316C248.122 141.571 247.215 143.73 245.532 145.238C243.86 146.738 241.629 147.401 239.416 147.059C226.746 145.103 215.657 146.703 208.584 148.39C208 148.529 207.412 148.598 206.831 148.598Z"
            fill="#2F3A79"
          />
          <path
            d="M205.419 81.0995L196.978 74.6456C196.978 74.6456 200.95 39.397 211.379 39.397C221.807 39.397 227.269 33.4395 227.269 33.4395C227.269 33.4395 264.513 85.5677 254.085 91.5252C243.657 97.4827 229.256 94.504 229.256 94.504L224.183 49.9726C223.56 47.6186 220.32 47.3637 219.336 49.5913L205.419 81.0995Z"
            fill="#CA373C"
          />
          <path
            d="M219.307 31.6119C227.279 31.6119 233.742 25.1509 233.742 17.1809C233.742 9.21095 227.279 2.75 219.307 2.75C211.335 2.75 204.873 9.21095 204.873 17.1809C204.873 25.1509 211.335 31.6119 219.307 31.6119Z"
            fill="#FFB6B6"
          />
          <path
            d="M230.738 28.0909C229.436 28.5769 227.44 29.3326 226.138 29.8187C224.923 27.3985 226.411 26.1427 226.566 23.4395C226.617 22.5374 226.747 21.6343 226.672 20.7338C226.598 19.8334 226.288 18.909 225.609 18.3132C224.569 17.4017 222.838 17.55 221.832 18.4979C220.826 19.4458 220.539 21.0122 220.951 22.3319C216.993 20.6214 214.436 16.1341 214.982 11.8582C213.8 11.3949 212.589 10.9255 211.32 10.89C210.051 10.8546 208.691 11.3387 208.015 12.4129C207.541 13.1661 207.446 14.1223 206.914 14.8357C206.049 15.995 204.18 16.0848 203.032 15.2055C201.884 14.3261 201.444 12.728 201.689 11.3028C201.934 9.87757 200.152 6.96906 201.15 5.92183C201.83 5.20743 205.208 6.21968 205.967 5.58948C206.659 5.01453 207.355 4.43767 208.118 3.96069C209.087 3.35524 210.16 2.91678 211.276 2.67041C212.332 2.43736 213.416 2.37615 214.496 2.31568C215.591 2.25429 217.107 0.0731585 218.203 0.0117658C221.429 -0.168977 224.312 1.77848 227.407 2.70564C230.502 3.63281 232.449 6.29529 234.162 9.03402C236.602 12.9351 235.773 17.2095 234.092 20.9397C233.677 21.8618 235.071 22.8307 234.864 23.8206C234.673 24.7408 233.81 25.4073 233.609 26.3254C233.436 27.1105 232.417 26.2009 232.174 26.9671C231.964 27.6282 231.346 28.0949 230.685 28.3059C230.024 28.517 229.317 28.5127 228.623 28.5064"
            fill="black"
          />
          <path
            d="M227.64 33.0703L228.148 33.4406L229.431 34.3742C233.287 37.1809 232.929 43.0398 228.759 45.3557L223.545 37.0292"
            fill="#CA373C"
          />
          <path
            d="M154.843 50.2438C156.145 51.1026 157.145 52.1841 157.753 53.2875L170.67 60.6858L166.969 66.7279L154.264 58.5726C153.01 58.4476 151.622 57.9539 150.321 57.0951C147.347 55.1331 145.948 52.009 147.197 50.117C148.446 48.2251 151.869 48.2818 154.843 50.2438Z"
            fill="#FFB6B6"
          />
          <path
            d="M215.62 42.4458C223.857 37.3952 232.135 48.9615 224.811 55.2633L224.786 55.2847L195.521 82.8029L160.497 65.512L163.96 56.1762L191.095 66.9224L211.45 45.7967C212.867 44.3784 214.261 43.2792 215.62 42.4458Z"
            fill="#2F3A79"
          />
        </g>
        <path
          d="M42.1282 88.3926C41.4478 88.3926 40.8945 88.9457 40.8945 89.626V108.744C40.8945 109.424 41.4478 109.977 42.1282 109.977C42.8087 109.977 43.362 109.424 43.362 108.744V89.626C43.362 88.9457 42.8087 88.3926 42.1282 88.3926Z"
          fill="black"
        />
        <path
          d="M54.2193 106.814C58.4653 106.814 61.9074 103.445 61.9074 99.2898C61.9074 95.1343 58.4653 91.7656 54.2193 91.7656C49.9733 91.7656 46.5312 95.1343 46.5312 99.2898C46.5312 103.445 49.9733 106.814 54.2193 106.814Z"
          fill="url(#paint0_radial_3694_8732)"
        />
        <path
          d="M115.851 96.7165H74.4693C73.0496 96.7165 71.8945 95.5617 71.8945 94.1424C71.8945 92.7231 73.0496 91.5684 74.4693 91.5684H115.851C117.271 91.5684 118.426 92.7231 118.426 94.1424C118.426 95.5617 117.271 96.7165 115.851 96.7165Z"
          fill="white"
        />
        <path
          d="M148.146 105.429H74.4693C73.0496 105.429 71.8945 104.275 71.8945 102.855C71.8945 101.436 73.0496 100.281 74.4693 100.281H148.146C149.565 100.281 150.72 101.436 150.72 102.855C150.72 104.275 149.565 105.429 148.146 105.429Z"
          fill="white"
        />
        <path
          d="M7.68808 147.503C11.9341 147.503 15.3762 144.135 15.3762 139.979C15.3762 135.824 11.9341 132.455 7.68808 132.455C3.44207 132.455 0 135.824 0 139.979C0 144.135 3.44207 147.503 7.68808 147.503Z"
          fill="url(#paint1_radial_3694_8732)"
        />
        <path
          d="M69.3199 137.406H27.938C26.5183 137.406 25.3633 136.251 25.3633 134.832C25.3633 133.413 26.5183 132.258 27.938 132.258H69.3199C70.7396 132.258 71.8946 133.413 71.8946 134.832C71.8946 136.251 70.7396 137.406 69.3199 137.406Z"
          fill="white"
        />
        <path
          d="M79.8961 172.179C84.1421 172.179 87.5842 168.811 87.5842 164.655C87.5842 160.5 84.1421 157.131 79.8961 157.131C75.6501 157.131 72.208 160.5 72.208 164.655C72.208 168.811 75.6501 172.179 79.8961 172.179Z"
          fill="url(#paint2_radial_3694_8732)"
        />
        <path
          d="M173.823 170.793H100.146C98.7268 170.793 97.5718 169.638 97.5718 168.219C97.5718 166.799 98.7268 165.645 100.146 165.645H173.823C175.243 165.645 176.398 166.799 176.398 168.219C176.398 169.638 175.243 170.793 173.823 170.793Z"
          fill="white"
        />
        <path
          d="M155.621 31.4898C159.867 31.4898 163.309 28.1211 163.309 23.9656C163.309 19.8101 159.867 16.4414 155.621 16.4414C151.375 16.4414 147.933 19.8101 147.933 23.9656C147.933 28.1211 151.375 31.4898 155.621 31.4898Z"
          fill="url(#paint3_radial_3694_8732)"
        />
        <path
          d="M297.135 157.628C301.381 157.628 304.823 154.26 304.823 150.104C304.823 145.949 301.381 142.58 297.135 142.58C292.889 142.58 289.447 145.949 289.447 150.104C289.447 154.26 292.889 157.628 297.135 157.628Z"
          fill="url(#paint4_radial_3694_8732)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3694_8732"
          x="112.303"
          y="3.50586"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter1_d_3694_8732"
          x="123.406"
          y="8.43945"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter2_d_3694_8732"
          x="244.927"
          y="123.146"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter3_d_3694_8732"
          x="136.74"
          y="-6"
          width="179.114"
          height="306.086"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <radialGradient
          id="paint0_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.2193 99.2898) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.68808 139.979) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(79.8961 164.655) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(155.621 23.9656) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(297.135 150.104) rotate(90) scale(7.52419 7.68807)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <clipPath id="clip0_3694_8732">
          <rect width="345" height="287" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
      <g id="Search_icon" data-name="Search icon" transform="translate(0.001 0)">
        <path
          id="Ellipse_642"
          data-name="Ellipse 642"
          d="M9,1.5A7.5,7.5,0,1,0,16.5,9,7.508,7.508,0,0,0,9,1.5M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"
          transform="translate(-0.001 0)"
          fill="#333"
        />
        <path
          id="Ellipse_643"
          data-name="Ellipse 643"
          d="M2.5,0A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z"
          transform="translate(15.999 15)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const NavigatorIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1410_7821)">
        <path
          d="M5.72727 2.86364C5.72727 1.28209 4.44518 0 2.86364 0C1.28209 0 0 1.28209 0 2.86364C0 4.44518 1.28209 5.72727 2.86364 5.72727C4.44518 5.72727 5.72727 4.44518 5.72727 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 2.86364C15.4546 1.28209 14.1725 0 12.5909 0C11.0094 0 9.72729 1.28209 9.72729 2.86364C9.72729 4.44518 11.0094 5.72727 12.5909 5.72727C14.1725 5.72727 15.4546 4.44518 15.4546 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 2.86364C25.1818 1.28209 23.8997 0 22.3182 0C20.7366 0 19.4545 1.28209 19.4545 2.86364C19.4545 4.44518 20.7366 5.72727 22.3182 5.72727C23.8997 5.72727 25.1818 4.44518 25.1818 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M5.72727 12.5909C5.72727 11.0094 4.44518 9.72726 2.86364 9.72726C1.28209 9.72726 0 11.0094 0 12.5909C0 14.1724 1.28209 15.4545 2.86364 15.4545C4.44518 15.4545 5.72727 14.1724 5.72727 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 12.5909C15.4546 11.0094 14.1725 9.72726 12.5909 9.72726C11.0094 9.72726 9.72729 11.0094 9.72729 12.5909C9.72729 14.1724 11.0094 15.4545 12.5909 15.4545C14.1725 15.4545 15.4546 14.1724 15.4546 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 12.5909C25.1818 11.0094 23.8997 9.72726 22.3182 9.72726C20.7366 9.72726 19.4545 11.0094 19.4545 12.5909C19.4545 14.1724 20.7366 15.4545 22.3182 15.4545C23.8997 15.4545 25.1818 14.1724 25.1818 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M5.72727 22.3182C5.72727 20.7366 4.44518 19.4545 2.86364 19.4545C1.28209 19.4545 0 20.7366 0 22.3182C0 23.8997 1.28209 25.1818 2.86364 25.1818C4.44518 25.1818 5.72727 23.8997 5.72727 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 22.3182C15.4546 20.7366 14.1725 19.4545 12.5909 19.4545C11.0094 19.4545 9.72729 20.7366 9.72729 22.3182C9.72729 23.8997 11.0094 25.1818 12.5909 25.1818C14.1725 25.1818 15.4546 23.8997 15.4546 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 22.3182C25.1818 20.7366 23.8997 19.4545 22.3182 19.4545C20.7366 19.4545 19.4545 20.7366 19.4545 22.3182C19.4545 23.8997 20.7366 25.1818 22.3182 25.1818C23.8997 25.1818 25.1818 23.8997 25.1818 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1410_7821">
          <rect width="26" height="25.1818" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"></path>
    </svg>
  );
};

export const Groups = () => {
  return (
    <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 22.5C17.5 21.9477 17.9477 21.5 18.5 21.5C19.0523 21.5 19.5 21.9477 19.5 22.5C19.5 23.0523 19.0523 23.5 18.5 23.5C17.9477 23.5 17.5 23.0523 17.5 22.5Z"
        fill="black"
      />
      <path
        d="M14.5 17C14.5 16.4477 14.9477 16 15.5 16C16.0523 16 16.5 16.4477 16.5 17C16.5 17.5523 16.0523 18 15.5 18C14.9477 18 14.5 17.5523 14.5 17Z"
        fill="black"
      />
      <path
        d="M24 15.5C24 14.9477 24.4477 14.5 25 14.5C25.5523 14.5 26 14.9477 26 15.5C26 16.0523 25.5523 16.5 25 16.5C24.4477 16.5 24 16.0523 24 15.5Z"
        fill="black"
      />
      <path
        d="M14.5 12C14.5 11.4477 14.9477 11 15.5 11C16.0523 11 16.5 11.4477 16.5 12C16.5 12.5523 16.0523 13 15.5 13C14.9477 13 14.5 12.5523 14.5 12Z"
        fill="black"
      />
      <path
        d="M11.5 6.5V2C11.5 1.44772 11.0523 1 10.5 1H6.25M11.5 6.5H24C24.5523 6.5 25 6.94772 25 7.5V15.5M11.5 6.5V12M11.5 6.5H6.25M6.25 1H2C1.44772 1 1 1.44772 1 2V6.5M6.25 1V6.5M6.25 22.5H2C1.44772 22.5 1 22.0523 1 21.5V17M6.25 22.5H11.5M6.25 22.5V17M11.5 22.5V17M11.5 22.5H18.5M1 17H6.25M1 17V12M6.25 17H11.5M6.25 17V12M11.5 17V12M11.5 17H15.5M1 12H6.25M1 12V6.5M6.25 12H11.5M6.25 12V6.5M11.5 12H15.5M6.25 6.5H1"
        stroke="black"
        stroke-width="2"
      />
      <path
        d="M19 16.5C19 16.2239 19.2239 16 19.5 16H20.5C20.7761 16 21 16.2239 21 16.5V17.5C21 17.7761 20.7761 18 20.5 18H19.5C19.2239 18 19 17.7761 19 17.5V16.5Z"
        fill="black"
      />
      <path
        d="M19 11.5C19 11.2239 19.2239 11 19.5 11H20.5C20.7761 11 21 11.2239 21 11.5V12.5C21 12.7761 20.7761 13 20.5 13H19.5C19.2239 13 19 12.7761 19 12.5V11.5Z"
        fill="black"
      />
      <path
        d="M24.8333 25.6667V21.8333M24.8333 21.8333V18M24.8333 21.8333H21M24.8333 21.8333H28.6667"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = () => (
  <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 1H1V3.89453C1 4.18512 1.11156 4.47593 1.31131 4.6771L7.06369 10.7347C7.26344 10.9358 7.375 11.2266 7.375 11.5172V16.6471L11.625 20V11.5172C11.625 11.2266 11.7366 10.9358 11.9363 10.7347L17.6887 4.6771C17.7875 4.57509 17.866 4.45346 17.9194 4.31911C17.9729 4.18475 18.0003 4.04018 18 3.89453V1Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.46875 12C1.46875 14.76 3.70775 17 6.46875 17H14.4688C17.2297 17 19.4688 14.76 19.4688 12M7.46875 9.18994C8.20875 10.1799 9.06775 11.0701 10.0247 11.8401C10.1547 11.9501 10.3117 12 10.4688 12M10.4688 12C10.6311 12.0014 10.7886 11.9447 10.9128 11.8401C11.8698 11.0701 12.7287 10.1799 13.4688 9.18994M10.4688 12V1"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Users = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2222 16.3333H6.11111C4.75556 16.3333 3.45553 16.8718 2.49701 17.8303C1.53849 18.7889 1 20.0889 1 21.4444C1 22.1222 1.26924 22.7722 1.7485 23.2515C2.22776 23.7308 2.87778 24 3.55556 24H16.3333M20.1667 20.1667V16.3333M20.1667 16.3333V12.5M20.1667 16.3333H16.3333M20.1667 16.3333H24M16.3333 6.11111C16.3333 7.46666 15.7948 8.7667 14.8363 9.72522C13.8778 10.6837 12.5778 11.2222 11.2222 11.2222C9.86667 11.2222 8.56664 10.6837 7.60812 9.72522C6.6496 8.7667 6.11111 7.46666 6.11111 6.11111C6.11111 4.75556 6.6496 3.45553 7.60812 2.49701C8.56664 1.53849 9.86667 1 11.2222 1C12.5778 1 13.8778 1.53849 14.8363 2.49701C15.7948 3.45553 16.3333 4.75556 16.3333 6.11111Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TeamsIcon = () => {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 1.64197C20.4352 2.47237 21.4 4.0228 21.4 5.8C21.4004 6.64281 21.1788 7.47087 20.7575 8.20081C20.3362 8.93075 19.73 9.53684 19 9.95803M23.8 22.2784C24.5176 21.8644 25 21.088 25 20.2C25.0004 19.3572 24.7788 18.5291 24.3575 17.7992C23.9362 17.0693 23.33 16.4632 22.6 16.042M15.4 5.8C15.4 7.07304 14.8943 8.29394 13.9941 9.19412C13.0939 10.0943 11.873 10.6 10.6 10.6C9.32696 10.6 8.10606 10.0943 7.20588 9.19412C6.30571 8.29394 5.8 7.07304 5.8 5.8C5.8 4.52696 6.30571 3.30606 7.20588 2.40588C8.10606 1.50571 9.32696 1 10.6 1C11.873 1 13.0939 1.50571 13.9941 2.40588C14.8943 3.30606 15.4 4.52696 15.4 5.8ZM5.8 15.4H15.4C16.673 15.4 17.8939 15.9057 18.7941 16.8059C19.6943 17.7061 20.2 18.927 20.2 20.2C20.2 20.8365 19.9471 21.4469 19.4971 21.897C19.047 22.3471 18.4365 22.6 17.8 22.6H3.4C2.76348 22.6 2.15303 22.3471 1.70294 21.897C1.25285 21.4469 1 20.8365 1 20.2C1 18.927 1.50571 17.7061 2.40588 16.8059C3.30606 15.9057 4.52696 15.4 5.8 15.4Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5.2666C1 3.77327 1 3.02678 1.29067 2.45345C1.54667 1.96012 1.95466 1.54663 2.45599 1.29329C3.02666 0.999961 3.77333 1 5.26666 1H6.06667C7.56 1 8.30667 0.999961 8.87734 1.29329C9.37867 1.54663 9.78666 1.96012 10.0427 2.45345C10.3333 3.02678 10.3333 3.77327 10.3333 5.2666V6.06673C10.3333 7.56007 10.3333 8.30655 10.0427 8.87988C9.78666 9.37322 9.37867 9.78671 8.87734 10.04C8.30667 10.3334 7.56 10.3333 6.06667 10.3333H5.26666C3.77333 10.3333 3.02666 10.3334 2.45599 10.04C1.95466 9.78671 1.54667 9.37322 1.29067 8.87988C1 8.30655 1 7.56007 1 6.06673V5.2666ZM1 19.9333C1 18.4399 1 17.6935 1.29067 17.1201C1.54667 16.6268 1.95466 16.2133 2.45599 15.96C3.02666 15.6666 3.77333 15.6667 5.26666 15.6667H6.06667C7.56 15.6667 8.30667 15.6666 8.87734 15.96C9.37867 16.2133 9.78666 16.6268 10.0427 17.1201C10.3333 17.6935 10.3333 18.4399 10.3333 19.9333V20.7334C10.3333 22.2267 10.3333 22.9732 10.0427 23.5466C9.78666 24.0399 9.37867 24.4534 8.87734 24.7067C8.30667 25 7.56 25 6.06667 25H5.26666C3.77333 25 3.02666 25 2.45599 24.7067C1.95466 24.4534 1.54667 24.0399 1.29067 23.5466C1 22.9732 1 22.2267 1 20.7334V19.9333ZM15.6667 5.2666C15.6667 3.77327 15.6667 3.02678 15.9573 2.45345C16.2133 1.96012 16.6213 1.54663 17.1227 1.29329C17.6933 0.999961 18.44 1 19.9333 1H20.7333C22.2267 1 22.9733 0.999961 23.544 1.29329C24.0453 1.54663 24.4533 1.96012 24.7093 2.45345C25 3.02678 25 3.77327 25 5.2666V6.06673C25 7.56007 25 8.30655 24.7093 8.87988C24.4533 9.37322 24.0453 9.78671 23.544 10.04C22.9733 10.3334 22.2267 10.3333 20.7333 10.3333H19.9333C18.44 10.3333 17.6933 10.3334 17.1227 10.04C16.6213 9.78671 16.2133 9.37322 15.9573 8.87988C15.6667 8.30655 15.6667 7.56007 15.6667 6.06673V5.2666ZM15.6667 19.9333C15.6667 18.4399 15.6667 17.6935 15.9573 17.1201C16.2133 16.6268 16.6213 16.2133 17.1227 15.96C17.6933 15.6666 18.44 15.6667 19.9333 15.6667H20.7333C22.2267 15.6667 22.9733 15.6666 23.544 15.96C24.0453 16.2133 24.4533 16.6268 24.7093 17.1201C25 17.6935 25 18.4399 25 19.9333V20.7334C25 22.2267 25 22.9732 24.7093 23.5466C24.4533 24.0399 24.0453 24.4534 23.544 24.7067C22.9733 25 22.2267 25 20.7333 25H19.9333C18.44 25 17.6933 25 17.1227 24.7067C16.6213 24.4534 16.2133 24.0399 15.9573 23.5466C15.6667 22.9732 15.6667 22.2267 15.6667 20.7334V19.9333Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ResourceIcon = () => {
  return (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 12.9985V25M12.5 12.9985L1.43444 7.17457M12.5 12.9985L18.0328 10.0801M12.5 25C12.7773 25 13.0558 24.9748 13.328 24.9116C13.9452 24.7979 14.5266 24.4693 15.6868 23.8377L20.8132 21.0332C21.9734 20.4015 22.5548 20.0857 22.9765 19.6435C23.3509 19.2393 23.632 18.7845 23.8045 18.2792C24 17.7107 24 17.0789 24 15.803V10.1939C24 8.91797 24 8.2862 23.8045 7.71771C23.7406 7.52821 23.6601 7.35143 23.5656 7.17457M12.5 25C12.2227 25 11.9442 24.9748 11.672 24.9116C11.0548 24.7979 10.4734 24.4693 9.31322 23.8377L4.18678 21.0332C3.02656 20.4015 2.44517 20.0857 2.0235 19.6435C1.65377 19.2512 1.37165 18.7864 1.1955 18.2792C1 17.7107 1 17.0789 1 15.803V10.1939C1 8.91797 1 8.2862 1.1955 7.71771C1.25939 7.52821 1.33988 7.35143 1.43444 7.17457M1.43444 7.17457C1.59161 6.88401 1.78967 6.60604 2.0235 6.35338C2.44517 5.91122 3.02656 5.59542 4.18678 4.96376L6.75 3.56149M18.0328 10.0801L23.5656 7.17457M18.0328 10.0801L6.75 3.56149M18.0328 10.0801V14.666M23.5656 7.17457C23.4045 6.87769 23.2066 6.60181 22.9765 6.35338C22.5548 5.91122 21.9734 5.59542 20.8132 4.96376L15.6868 2.15922C14.5266 1.52756 13.9452 1.19898 13.328 1.08528C12.782 0.971574 12.218 0.971574 11.672 1.08528C11.0548 1.19898 10.4734 1.52756 9.31322 2.15922L6.75 3.56149"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BackArrowIcon = () => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.35833 1C4.60935 2.29326 3.03515 3.80752 1.675 5.505C1.56182 5.64516 1.50006 5.81985 1.5 6M1.5 6C1.50006 6.18015 1.56182 6.35484 1.675 6.49499C3.03515 8.19248 4.60935 9.70674 6.35833 11M1.5 6H16.5"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ApplicationIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5.2666C1 3.77327 1 3.02678 1.29067 2.45345C1.54667 1.96012 1.95466 1.54663 2.45599 1.29329C3.02666 0.999961 3.77333 1 5.26666 1H6.06667C7.56 1 8.30667 0.999961 8.87734 1.29329C9.37867 1.54663 9.78666 1.96012 10.0427 2.45345C10.3333 3.02678 10.3333 3.77327 10.3333 5.2666V6.06673C10.3333 7.56007 10.3333 8.30655 10.0427 8.87988C9.78666 9.37322 9.37867 9.78671 8.87734 10.04C8.30667 10.3334 7.56 10.3333 6.06667 10.3333H5.26666C3.77333 10.3333 3.02666 10.3334 2.45599 10.04C1.95466 9.78671 1.54667 9.37322 1.29067 8.87988C1 8.30655 1 7.56007 1 6.06673V5.2666ZM1 19.9333C1 18.4399 1 17.6935 1.29067 17.1201C1.54667 16.6268 1.95466 16.2133 2.45599 15.96C3.02666 15.6666 3.77333 15.6667 5.26666 15.6667H6.06667C7.56 15.6667 8.30667 15.6666 8.87734 15.96C9.37867 16.2133 9.78666 16.6268 10.0427 17.1201C10.3333 17.6935 10.3333 18.4399 10.3333 19.9333V20.7334C10.3333 22.2267 10.3333 22.9732 10.0427 23.5466C9.78666 24.0399 9.37867 24.4534 8.87734 24.7067C8.30667 25 7.56 25 6.06667 25H5.26666C3.77333 25 3.02666 25 2.45599 24.7067C1.95466 24.4534 1.54667 24.0399 1.29067 23.5466C1 22.9732 1 22.2267 1 20.7334V19.9333ZM15.6667 5.2666C15.6667 3.77327 15.6667 3.02678 15.9573 2.45345C16.2133 1.96012 16.6213 1.54663 17.1227 1.29329C17.6933 0.999961 18.44 1 19.9333 1H20.7333C22.2267 1 22.9733 0.999961 23.544 1.29329C24.0453 1.54663 24.4533 1.96012 24.7093 2.45345C25 3.02678 25 3.77327 25 5.2666V6.06673C25 7.56007 25 8.30655 24.7093 8.87988C24.4533 9.37322 24.0453 9.78671 23.544 10.04C22.9733 10.3334 22.2267 10.3333 20.7333 10.3333H19.9333C18.44 10.3333 17.6933 10.3334 17.1227 10.04C16.6213 9.78671 16.2133 9.37322 15.9573 8.87988C15.6667 8.30655 15.6667 7.56007 15.6667 6.06673V5.2666ZM15.6667 19.9333C15.6667 18.4399 15.6667 17.6935 15.9573 17.1201C16.2133 16.6268 16.6213 16.2133 17.1227 15.96C17.6933 15.6666 18.44 15.6667 19.9333 15.6667H20.7333C22.2267 15.6667 22.9733 15.6666 23.544 15.96C24.0453 16.2133 24.4533 16.6268 24.7093 17.1201C25 17.6935 25 18.4399 25 19.9333V20.7334C25 22.2267 25 22.9732 24.7093 23.5466C24.4533 24.0399 24.0453 24.4534 23.544 24.7067C22.9733 25 22.2267 25 20.7333 25H19.9333C18.44 25 17.6933 25 17.1227 24.7067C16.6213 24.4534 16.2133 24.0399 15.9573 23.5466C15.6667 22.9732 15.6667 22.2267 15.6667 20.7334V19.9333Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PLusIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 15V8M8 8V1M8 8H1M8 8H15"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RemoveIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.05025 10.9498L6 6.00008M6 6.00008L10.9497 1.05033M6 6.00008L1.05025 1.05033M6 6.00008L10.9497 10.9498"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const FileUploadIcon = () => {
  return (
    <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 1.06962V2.44001C13 4.45601 13 5.464 13.3924 6.2344C13.7378 6.91156 14.2884 7.4622 14.9656 7.80761C15.736 8.20001 16.744 8.2 18.76 8.2H20.1304M13 1.06962C12.5272 1.00002 11.9632 1 11.0188 1H8.67999C5.99199 1 4.64801 1.00001 3.62081 1.52321C2.71723 1.98278 1.98278 2.71721 1.52321 3.62079C1.00001 4.64799 1 5.99199 1 8.67999V17.32C1 20.008 1.00001 21.352 1.52321 22.3792C1.98312 23.2825 2.71747 24.0169 3.62081 24.4768C4.64801 25 5.99199 25 8.67999 25H12.52C15.208 25 16.552 25 17.5792 24.4768C18.4823 24.0165 19.2165 23.2823 19.6768 22.3792C20.2 21.352 20.2 20.008 20.2 17.32V10.1812C20.2 9.2368 20.2 8.6728 20.1304 8.2M13 1.06962C13.1152 1.08642 13.2244 1.10679 13.3324 1.13319C13.822 1.25079 14.29 1.44399 14.7196 1.70679C15.2044 2.00439 15.6196 2.4196 16.45 3.25L17.95 4.75C18.7804 5.5804 19.1956 5.99558 19.4932 6.48038C19.756 6.90998 19.9492 7.37799 20.0668 7.86759C20.0932 7.97559 20.1136 8.0848 20.1304 8.2M10.6 19V11.8M10.6 11.8C10.4707 11.8 10.3452 11.8445 10.2448 11.926C9.4784 12.5467 8.7916 13.2597 8.2 14.0488M10.6 11.8C10.7293 11.8 10.8548 11.8445 10.9552 11.926C11.7216 12.5467 12.4084 13.2597 13 14.0488"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const defaultLogo = "https://cdn.simulanis.io/sso/logos/obsys.png";

export const ThreeDotsIcon = () => (
  <svg width="5" height="26" viewBox="0 0 5 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 4C1.672 4 1 3.325 1 2.5C1 1.675 1.672 1 2.5 1C3.328 1 4 1.675 4 2.5C4 3.325 3.328 4 2.5 4ZM2.5 14.5C1.672 14.5 1 13.825 1 13C1 12.175 1.672 11.5 2.5 11.5C3.328 11.5 4 12.175 4 13C4 13.825 3.328 14.5 2.5 14.5ZM2.5 25C1.672 25 1 24.325 1 23.5C1 22.675 1.672 22 2.5 22C3.328 22 4 22.675 4 23.5C4 24.325 3.328 25 2.5 25Z"
      fill="black"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.38916 13.8916C6.50472 13.8916 5.67106 13.7223 4.88818 13.3838C4.10954 13.0452 3.42188 12.5776 2.8252 11.981C2.22852 11.3843 1.7609 10.6966 1.42236 9.91797C1.08382 9.13509 0.914551 8.30143 0.914551 7.41699C0.914551 6.53255 1.08382 5.70101 1.42236 4.92236C1.7609 4.13949 2.2264 3.44971 2.81885 2.85303C3.41553 2.25635 4.10319 1.78874 4.88184 1.4502C5.66471 1.11165 6.49837 0.942383 7.38281 0.942383C8.26725 0.942383 9.10091 1.11165 9.88379 1.4502C10.6667 1.78874 11.3564 2.25635 11.9531 2.85303C12.5498 3.44971 13.0174 4.13949 13.356 4.92236C13.6945 5.70101 13.8638 6.53255 13.8638 7.41699C13.8638 8.30143 13.6945 9.13509 13.356 9.91797C13.0174 10.6966 12.5498 11.3843 11.9531 11.981C11.3564 12.5776 10.6667 13.0452 9.88379 13.3838C9.10514 13.7223 8.2736 13.8916 7.38916 13.8916ZM7.38916 12.8125C8.13818 12.8125 8.83854 12.6729 9.49023 12.3936C10.1462 12.1143 10.7196 11.7292 11.2104 11.2383C11.7056 10.7432 12.0907 10.1698 12.3657 9.51807C12.645 8.86637 12.7847 8.16602 12.7847 7.41699C12.7847 6.66797 12.645 5.96761 12.3657 5.31592C12.0864 4.66423 11.6992 4.09082 11.2041 3.5957C10.709 3.10059 10.1356 2.71549 9.48389 2.44043C8.83219 2.16113 8.13184 2.02148 7.38281 2.02148C6.63379 2.02148 5.93343 2.16113 5.28174 2.44043C4.63005 2.71549 4.05876 3.10059 3.56787 3.5957C3.07699 4.09082 2.69189 4.66423 2.4126 5.31592C2.13753 5.96761 2 6.66797 2 7.41699C2 8.16602 2.13753 8.86637 2.4126 9.51807C2.69189 10.1698 3.07699 10.7432 3.56787 11.2383C4.06299 11.7292 4.63639 12.1143 5.28809 12.3936C5.93978 12.6729 6.64014 12.8125 7.38916 12.8125ZM6.27832 10.9082C6.14714 10.9082 6.03711 10.8659 5.94824 10.7812C5.85938 10.6966 5.81494 10.5908 5.81494 10.4639C5.81494 10.3369 5.85938 10.2311 5.94824 10.1465C6.03711 10.0618 6.14714 10.0195 6.27832 10.0195H7.06543V7.10596H6.38623C6.25505 7.10596 6.14502 7.06364 6.05615 6.979C5.96729 6.89437 5.92285 6.78857 5.92285 6.66162C5.92285 6.53467 5.96729 6.42887 6.05615 6.34424C6.14502 6.2596 6.25505 6.21729 6.38623 6.21729H7.57959C7.7404 6.21729 7.86312 6.27018 7.94775 6.37598C8.03239 6.47754 8.07471 6.61507 8.07471 6.78857V10.0195H8.86182C8.993 10.0195 9.10303 10.0618 9.19189 10.1465C9.28076 10.2311 9.3252 10.3369 9.3252 10.4639C9.3252 10.5908 9.28076 10.6966 9.19189 10.7812C9.10303 10.8659 8.993 10.9082 8.86182 10.9082H6.27832ZM7.33203 5.15723C7.10352 5.15723 6.90885 5.07682 6.74805 4.91602C6.58724 4.75521 6.50684 4.56055 6.50684 4.33203C6.50684 4.09928 6.58724 3.90251 6.74805 3.7417C6.90885 3.58089 7.10352 3.50049 7.33203 3.50049C7.56478 3.50049 7.75944 3.58089 7.91602 3.7417C8.07682 3.90251 8.15723 4.09928 8.15723 4.33203C8.15723 4.56055 8.07682 4.75521 7.91602 4.91602C7.75944 5.07682 7.56478 5.15723 7.33203 5.15723Z"
      fill="black"
      fill-opacity="0.5"
    />
  </svg>
);

export const AddIcon = () => {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-plus-lg"
    viewBox="0 0 16 16"
  >
    <path
      fill-rule="evenodd"
      d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
    />
  </svg>;
};

export const UploadIcon = () => {
  return (
    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 12C1 14.76 3.48778 17 6.55556 17H15.4444C18.5122 17 21 14.76 21 12M7.66667 3.81008C8.48889 2.82008 9.44333 1.92994 10.5067 1.15994C10.6446 1.05531 10.8196 0.998642 11 1.00002M11 1.00002C11.1804 0.998642 11.3554 1.05531 11.4933 1.15994C12.5567 1.92994 13.5111 2.82008 14.3333 3.81008M11 1.00002V12"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CircleLoading = () => {
  return (
    <svg viewBox="25 25 50 50">
      <circle r="20" cy="50" cx="50">
        {""}
      </circle>
    </svg>
  );
};

export const RoleManagementIcon = () => {
  return (
    <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.352 25H4.11689C3.70777 25.0005 3.30256 24.9205 2.92442 24.7646C2.54629 24.6088 2.20265 24.38 1.91316 24.0915C1.62368 23.8029 1.39402 23.4603 1.23733 23.0832C1.08064 22.706 1 22.3017 1 21.8934C1 18.4534 3.79093 15.6667 7.23515 15.6667H10.352M17.0321 6.33333C17.0321 7.74782 16.4691 9.1043 15.4669 10.1045C14.4647 11.1047 13.1054 11.6667 11.6881 11.6667C10.2707 11.6667 8.91145 11.1047 7.90925 10.1045C6.90705 9.1043 6.34403 7.74782 6.34403 6.33333C6.34403 4.91884 6.90705 3.56237 7.90925 2.56217C8.91145 1.56198 10.2707 1 11.6881 1C13.1054 1 14.4647 1.56198 15.4669 2.56217C16.4691 3.56237 17.0321 4.91884 17.0321 6.33333ZM16.2799 21.6913L17.6159 23.4687L17.6192 23.4731C18.1968 24.2421 18.4863 24.6276 18.8424 24.7646C19.1533 24.886 19.4987 24.886 19.8096 24.7646C20.1657 24.6276 20.4552 24.2421 21.0328 23.4731L21.0361 23.4687L22.3721 21.6913C22.7168 21.2327 22.8891 21.0033 22.9559 20.7513C23.0147 20.5284 23.0147 20.2942 22.9559 20.0713C22.8891 19.8193 22.7168 19.5899 22.3721 19.1313L21.0361 17.3539L21.0328 17.3495C20.4551 16.5804 20.1657 16.195 19.8096 16.0579C19.4987 15.9366 19.1533 15.9366 18.8424 16.0579C18.4863 16.195 18.1969 16.5804 17.6192 17.3495L17.6159 17.3539L16.2799 19.1313C15.9352 19.5899 15.7629 19.8193 15.6961 20.0713C15.6373 20.2942 15.6373 20.5284 15.6961 20.7513C15.7629 21.0033 15.9352 21.2327 16.2799 21.6913Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const FeedbackIcon = () => {
  return (
    <svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 11.8C20 9.808 18.4052 8.2 16.4375 8.2H15.725C15.2832 8.2 15.0636 8.19998 14.8783 8.17598C14.3823 8.09483 13.9243 7.85737 13.5699 7.49746C13.2154 7.13755 12.9826 6.6737 12.9047 6.17207C12.875 5.99207 12.875 5.76412 12.875 5.32012V4.6C12.875 2.608 11.2802 1 9.3125 1M5.75 14.2H15.25M5.75 19H11.6875M20 10.6V20.2C20 21.473 19.4996 22.6939 18.6088 23.594C17.718 24.4942 16.5098 25 15.25 25H5.75C4.49022 25 3.28204 24.4942 2.39124 23.594C1.50044 22.6939 1 21.473 1 20.2V5.8C1 4.52696 1.50044 3.30613 2.39124 2.40596C3.28204 1.50578 4.49022 1 5.75 1H10.5C13.0196 1 15.4359 2.01156 17.2175 3.81191C18.9991 5.61226 20 8.05392 20 10.6Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const AppDrawerIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.75 22C1.99375 22 1.34635 21.7307 0.807813 21.1922C0.269271 20.6536 0 20.0063 0 19.25C0 18.4937 0.269271 17.8464 0.807813 17.3078C1.34635 16.7693 1.99375 16.5 2.75 16.5C3.50625 16.5 4.15365 16.7693 4.69219 17.3078C5.23073 17.8464 5.5 18.4937 5.5 19.25C5.5 20.0063 5.23073 20.6536 4.69219 21.1922C4.15365 21.7307 3.50625 22 2.75 22ZM11 22C10.2437 22 9.59635 21.7307 9.05781 21.1922C8.51927 20.6536 8.25 20.0063 8.25 19.25C8.25 18.4937 8.51927 17.8464 9.05781 17.3078C9.59635 16.7693 10.2437 16.5 11 16.5C11.7563 16.5 12.4036 16.7693 12.9422 17.3078C13.4807 17.8464 13.75 18.4937 13.75 19.25C13.75 20.0063 13.4807 20.6536 12.9422 21.1922C12.4036 21.7307 11.7563 22 11 22ZM19.25 22C18.4937 22 17.8464 21.7307 17.3078 21.1922C16.7693 20.6536 16.5 20.0063 16.5 19.25C16.5 18.4937 16.7693 17.8464 17.3078 17.3078C17.8464 16.7693 18.4937 16.5 19.25 16.5C20.0063 16.5 20.6536 16.7693 21.1922 17.3078C21.7307 17.8464 22 18.4937 22 19.25C22 20.0063 21.7307 20.6536 21.1922 21.1922C20.6536 21.7307 20.0063 22 19.25 22ZM2.75 13.75C1.99375 13.75 1.34635 13.4807 0.807813 12.9422C0.269271 12.4036 0 11.7563 0 11C0 10.2437 0.269271 9.59635 0.807813 9.05781C1.34635 8.51927 1.99375 8.25 2.75 8.25C3.50625 8.25 4.15365 8.51927 4.69219 9.05781C5.23073 9.59635 5.5 10.2437 5.5 11C5.5 11.7563 5.23073 12.4036 4.69219 12.9422C4.15365 13.4807 3.50625 13.75 2.75 13.75ZM11 13.75C10.2437 13.75 9.59635 13.4807 9.05781 12.9422C8.51927 12.4036 8.25 11.7563 8.25 11C8.25 10.2437 8.51927 9.59635 9.05781 9.05781C9.59635 8.51927 10.2437 8.25 11 8.25C11.7563 8.25 12.4036 8.51927 12.9422 9.05781C13.4807 9.59635 13.75 10.2437 13.75 11C13.75 11.7563 13.4807 12.4036 12.9422 12.9422C12.4036 13.4807 11.7563 13.75 11 13.75ZM19.25 13.75C18.4937 13.75 17.8464 13.4807 17.3078 12.9422C16.7693 12.4036 16.5 11.7563 16.5 11C16.5 10.2437 16.7693 9.59635 17.3078 9.05781C17.8464 8.51927 18.4937 8.25 19.25 8.25C20.0063 8.25 20.6536 8.51927 21.1922 9.05781C21.7307 9.59635 22 10.2437 22 11C22 11.7563 21.7307 12.4036 21.1922 12.9422C20.6536 13.4807 20.0063 13.75 19.25 13.75ZM2.75 5.5C1.99375 5.5 1.34635 5.23073 0.807813 4.69219C0.269271 4.15365 0 3.50625 0 2.75C0 1.99375 0.269271 1.34635 0.807813 0.807813C1.34635 0.269271 1.99375 0 2.75 0C3.50625 0 4.15365 0.269271 4.69219 0.807813C5.23073 1.34635 5.5 1.99375 5.5 2.75C5.5 3.50625 5.23073 4.15365 4.69219 4.69219C4.15365 5.23073 3.50625 5.5 2.75 5.5ZM11 5.5C10.2437 5.5 9.59635 5.23073 9.05781 4.69219C8.51927 4.15365 8.25 3.50625 8.25 2.75C8.25 1.99375 8.51927 1.34635 9.05781 0.807813C9.59635 0.269271 10.2437 0 11 0C11.7563 0 12.4036 0.269271 12.9422 0.807813C13.4807 1.34635 13.75 1.99375 13.75 2.75C13.75 3.50625 13.4807 4.15365 12.9422 4.69219C12.4036 5.23073 11.7563 5.5 11 5.5ZM19.25 5.5C18.4937 5.5 17.8464 5.23073 17.3078 4.69219C16.7693 4.15365 16.5 3.50625 16.5 2.75C16.5 1.99375 16.7693 1.34635 17.3078 0.807813C17.8464 0.269271 18.4937 0 19.25 0C20.0063 0 20.6536 0.269271 21.1922 0.807813C21.7307 1.34635 22 1.99375 22 2.75C22 3.50625 21.7307 4.15365 21.1922 4.69219C20.6536 5.23073 20.0063 5.5 19.25 5.5Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};

export const SliderLeftIcon = () => {
  return (
    <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.74693 1.875C4.35867 2.90153 3.10915 4.10347 2.02953 5.45085C1.9397 5.5621 1.89067 5.70076 1.89062 5.84375M1.89062 5.84375C1.89067 5.98674 1.9397 6.1254 2.02953 6.23665C3.10915 7.58403 4.35867 8.78597 5.74693 9.8125M1.89062 5.84375H13.7969"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SliderRightIcon = () => {
  return (
    <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.49331 1.875C10.9165 2.90153 12.1975 4.10347 13.3044 5.45085C13.3965 5.5621 13.4467 5.70076 13.4468 5.84375M13.4468 5.84375C13.4467 5.98674 13.3965 6.1254 13.3044 6.23665C12.1975 7.58403 10.9165 8.78597 9.49331 9.8125M13.4468 5.84375H1.24053"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ApplicationIconBottom = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.7998 15.1504C5.84937 15.1504 6.74089 15.4929 7.50781 16.1953L7.66016 16.3398C8.46063 17.1403 8.84961 18.0807 8.84961 19.2002C8.84957 20.2498 8.50721 21.1413 7.80469 21.9082L7.66016 22.0596C6.85969 22.86 5.91931 23.25 4.7998 23.25C3.68038 23.25 2.74085 22.86 1.94043 22.0596C1.14001 21.2591 0.750045 20.3196 0.75 19.2002C0.75 18.0807 1.13996 17.1403 1.94043 16.3398C2.74079 15.5396 3.68052 15.1504 4.7998 15.1504ZM19.2002 15.1504C20.3195 15.1504 21.2592 15.5396 22.0596 16.3398C22.86 17.1403 23.25 18.0807 23.25 19.2002C23.25 20.3196 22.86 21.2591 22.0596 22.0596C21.2591 22.86 20.3196 23.25 19.2002 23.25C18.0807 23.25 17.1403 22.86 16.3398 22.0596C15.5396 21.2592 15.1504 20.3195 15.1504 19.2002C15.1504 18.0807 15.5394 17.1403 16.3398 16.3398C17.1403 15.5394 18.0807 15.1504 19.2002 15.1504ZM4.7998 0.75C5.84928 0.75 6.74094 1.09261 7.50781 1.79492L7.66016 1.94043C8.46038 2.74079 8.84956 3.68052 8.84961 4.7998C8.84961 5.84937 8.50712 6.74089 7.80469 7.50781L7.66016 7.66016C6.85969 8.46063 5.91931 8.84961 4.7998 8.84961C3.75023 8.84957 2.85872 8.50721 2.0918 7.80469L1.94043 7.66016C1.13996 6.85969 0.75 5.91931 0.75 4.7998C0.750045 3.68038 1.14001 2.74085 1.94043 1.94043C2.74085 1.14001 3.68038 0.750045 4.7998 0.75ZM19.2002 0.75C20.3196 0.750045 21.2591 1.14001 22.0596 1.94043C22.86 2.74085 23.25 3.68038 23.25 4.7998C23.25 5.84928 22.9074 6.74094 22.2051 7.50781L22.0596 7.66016C21.2592 8.46038 20.3195 8.84956 19.2002 8.84961C18.1506 8.84961 17.2591 8.50712 16.4922 7.80469L16.3398 7.66016C15.5394 6.85969 15.1504 5.91931 15.1504 4.7998C15.1504 3.68052 15.5396 2.74079 16.3398 1.94043C17.1403 1.13996 18.0807 0.75 19.2002 0.75Z"
        stroke="black"
        stroke-width="1.5"
      />
    </svg>
  );
};

export const ApplicationIconBottomActive = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.8 24C3.48 24 2.35 23.53 1.41 22.59C0.47 21.65 0 20.52 0 19.2C0 17.88 0.47 16.75 1.41 15.81C2.35 14.87 3.48 14.4 4.8 14.4C6.12 14.4 7.25 14.87 8.19 15.81C9.13 16.75 9.6 17.88 9.6 19.2C9.6 20.52 9.13 21.65 8.19 22.59C7.25 23.53 6.12 24 4.8 24ZM19.2 9.6C17.88 9.6 16.75 9.13 15.81 8.19C14.87 7.25 14.4 6.12 14.4 4.8C14.4 3.48 14.87 2.35 15.81 1.41C16.75 0.47 17.88 0 19.2 0C20.52 0 21.65 0.47 22.59 1.41C23.53 2.35 24 3.48 24 4.8C24 6.12 23.53 7.25 22.59 8.19C21.65 9.13 20.52 9.6 19.2 9.6Z"
        fill="#2F3A79"
      />
      <path
        d="M-0.00012207 4.8C-0.00012207 3.48 0.469875 2.35 1.40988 1.41C2.34988 0.47 3.47988 0 4.79988 0C6.11988 0 7.24988 0.47 8.18988 1.41C9.12988 2.35 9.59988 3.48 9.59988 4.8C9.59988 6.12 9.12988 7.25 8.18988 8.19C7.24988 9.13 6.11988 9.6 4.79988 9.6C3.47988 9.6 2.34988 9.13 1.40988 8.19C0.469875 7.25 -0.00012207 6.12 -0.00012207 4.8ZM14.3999 19.2C14.3999 17.88 14.8699 16.75 15.8099 15.81C16.7499 14.87 17.8799 14.4 19.1999 14.4C20.5199 14.4 21.6499 14.87 22.5899 15.81C23.5299 16.75 23.9999 17.88 23.9999 19.2C23.9999 20.52 23.5299 21.65 22.5899 22.59C21.6499 23.53 20.5199 24 19.1999 24C17.8799 24 16.7499 23.53 15.8099 22.59C14.8699 21.65 14.3999 20.52 14.3999 19.2Z"
        fill="black"
        fill-opacity="0.3"
      />
      <path
        d="M4.7998 15.1504C5.84937 15.1504 6.74089 15.4929 7.50781 16.1953L7.66016 16.3398C8.46063 17.1403 8.84961 18.0807 8.84961 19.2002C8.84957 20.2498 8.50721 21.1413 7.80469 21.9082L7.66016 22.0596C6.85969 22.86 5.91931 23.25 4.7998 23.25C3.68038 23.25 2.74085 22.86 1.94043 22.0596C1.14001 21.2591 0.750045 20.3196 0.75 19.2002C0.75 18.0807 1.13996 17.1403 1.94043 16.3398C2.74079 15.5396 3.68052 15.1504 4.7998 15.1504ZM19.2002 15.1504C20.3195 15.1504 21.2592 15.5396 22.0596 16.3398C22.86 17.1403 23.25 18.0807 23.25 19.2002C23.25 20.3196 22.86 21.2591 22.0596 22.0596C21.2591 22.86 20.3196 23.25 19.2002 23.25C18.0807 23.25 17.1403 22.86 16.3398 22.0596C15.5396 21.2592 15.1504 20.3195 15.1504 19.2002C15.1504 18.0807 15.5394 17.1403 16.3398 16.3398C17.1403 15.5394 18.0807 15.1504 19.2002 15.1504ZM4.7998 0.75C5.84928 0.75 6.74094 1.09261 7.50781 1.79492L7.66016 1.94043C8.46038 2.74079 8.84956 3.68052 8.84961 4.7998C8.84961 5.84937 8.50712 6.74089 7.80469 7.50781L7.66016 7.66016C6.85969 8.46063 5.91931 8.84961 4.7998 8.84961C3.75023 8.84957 2.85872 8.50721 2.0918 7.80469L1.94043 7.66016C1.13996 6.85969 0.75 5.91931 0.75 4.7998C0.750045 3.68038 1.14001 2.74085 1.94043 1.94043C2.74085 1.14001 3.68038 0.750045 4.7998 0.75ZM19.2002 0.75C20.3196 0.750045 21.2591 1.14001 22.0596 1.94043C22.86 2.74085 23.25 3.68038 23.25 4.7998C23.25 5.84928 22.9074 6.74094 22.2051 7.50781L22.0596 7.66016C21.2592 8.46038 20.3195 8.84956 19.2002 8.84961C18.1506 8.84961 17.2591 8.50712 16.4922 7.80469L16.3398 7.66016C15.5394 6.85969 15.1504 5.91931 15.1504 4.7998C15.1504 3.68052 15.5396 2.74079 16.3398 1.94043C17.1403 1.13996 18.0807 0.75 19.2002 0.75Z"
        stroke="black"
        stroke-width="1.5"
      />
    </svg>
  );
};

export const TeamsIconBottom = () => {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.25 1.84216C20.6852 2.67256 21.65 4.223 21.65 6.0002C21.6504 6.843 21.4288 7.67106 21.0075 8.401C20.5862 9.13094 19.98 9.73704 19.25 10.1582M24.05 22.4786C24.7676 22.0646 25.25 21.2882 25.25 20.4002C25.2504 19.5574 25.0288 18.7293 24.6075 17.9994C24.1862 17.2694 23.58 16.6634 22.85 16.2422M15.65 6.0002C15.65 7.27323 15.1443 8.49414 14.2441 9.39431C13.3439 10.2945 12.123 10.8002 10.85 10.8002C9.57696 10.8002 8.35606 10.2945 7.45588 9.39431C6.55571 8.49414 6.05 7.27323 6.05 6.0002C6.05 4.72716 6.55571 3.50625 7.45588 2.60608C8.35606 1.7059 9.57696 1.2002 10.85 1.2002C12.123 1.2002 13.3439 1.7059 14.2441 2.60608C15.1443 3.50625 15.65 4.72716 15.65 6.0002ZM6.05 15.6002H15.65C16.923 15.6002 18.1439 16.1059 19.0441 17.0061C19.9443 17.9063 20.45 19.1272 20.45 20.4002C20.45 21.0367 20.1971 21.6471 19.7471 22.0972C19.297 22.5473 18.6865 22.8002 18.05 22.8002H3.65C3.01348 22.8002 2.40303 22.5473 1.95294 22.0972C1.50285 21.6471 1.25 21.0367 1.25 20.4002C1.25 19.1272 1.75571 17.9063 2.65588 17.0061C3.55606 16.1059 4.77696 15.6002 6.05 15.6002Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TeamsIconBottomActive = () => {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6441 9.39407C15.5443 8.49389 16.05 7.27299 16.05 5.99995C16.05 4.72691 15.5443 3.50601 14.6441 2.60583C13.744 1.70566 12.5231 1.19995 11.25 1.19995C9.97698 1.19995 8.75608 1.70566 7.85591 2.60583C6.95573 3.50601 6.45002 4.72691 6.45002 5.99995C6.45002 7.27299 6.95573 8.49389 7.85591 9.39407C8.75608 10.2942 9.97698 10.8 11.25 10.8C12.5231 10.8 13.744 10.2942 14.6441 9.39407Z"
        fill="#2F3A79"
      />
      <path
        d="M16.05 15.6H6.45002C5.17699 15.6 3.95608 16.1057 3.05591 17.0058C2.15573 17.906 1.65002 19.1269 1.65002 20.4C1.65002 21.0365 1.90288 21.6469 2.35297 22.097C2.80305 22.5471 3.4135 22.8 4.05002 22.8H18.45C19.0865 22.8 19.697 22.5471 20.1471 22.097C20.5972 21.6469 20.85 21.0365 20.85 20.4C20.85 19.1269 20.3443 17.906 19.4441 17.0058C18.544 16.1057 17.3231 15.6 16.05 15.6Z"
        fill="#2F3A79"
      />
      <path
        d="M19.25 1.84192C20.6852 2.67232 21.65 4.22275 21.65 5.99995C21.6504 6.84276 21.4288 7.67082 21.0075 8.40076C20.5862 9.1307 19.98 9.73679 19.25 10.158M24.05 22.4783C24.7676 22.0643 25.25 21.288 25.25 20.4C25.2504 19.5571 25.0288 18.7291 24.6075 17.9991C24.1862 17.2692 23.58 16.6631 22.85 16.2419M15.65 5.99995C15.65 7.27299 15.1443 8.49389 14.2441 9.39407C13.3439 10.2942 12.123 10.8 10.85 10.8C9.57696 10.8 8.35606 10.2942 7.45588 9.39407C6.55571 8.49389 6.05 7.27299 6.05 5.99995C6.05 4.72691 6.55571 3.50601 7.45588 2.60583C8.35606 1.70566 9.57696 1.19995 10.85 1.19995C12.123 1.19995 13.3439 1.70566 14.2441 2.60583C15.1443 3.50601 15.65 4.72691 15.65 5.99995ZM6.05 15.6H15.65C16.923 15.6 18.1439 16.1057 19.0441 17.0058C19.9443 17.906 20.45 19.1269 20.45 20.4C20.45 21.0365 20.1971 21.6469 19.7471 22.097C19.297 22.5471 18.6865 22.8 18.05 22.8H3.65C3.01348 22.8 2.40303 22.5471 1.95294 22.097C1.50285 21.6469 1.25 21.0365 1.25 20.4C1.25 19.1269 1.75571 17.906 2.65588 17.0058C3.55606 16.1057 4.77696 15.6 6.05 15.6Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ResourceIconBottom = () => {
  return (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 12.9985V25M12.5 12.9985L1.43444 7.17457M12.5 12.9985L18.0328 10.0801M12.5 25C12.7773 25 13.0558 24.9748 13.328 24.9116C13.9452 24.7979 14.5266 24.4693 15.6868 23.8377L20.8132 21.0332C21.9734 20.4015 22.5548 20.0857 22.9765 19.6435C23.3509 19.2393 23.632 18.7845 23.8045 18.2792C24 17.7107 24 17.0789 24 15.803V10.1939C24 8.91797 24 8.2862 23.8045 7.71771C23.7406 7.52821 23.6601 7.35143 23.5656 7.17457M12.5 25C12.2227 25 11.9442 24.9748 11.672 24.9116C11.0548 24.7979 10.4734 24.4693 9.31322 23.8377L4.18678 21.0332C3.02656 20.4015 2.44517 20.0857 2.0235 19.6435C1.65377 19.2512 1.37165 18.7864 1.1955 18.2792C1 17.7107 1 17.0789 1 15.803V10.1939C1 8.91797 1 8.2862 1.1955 7.71771C1.25939 7.52821 1.33988 7.35143 1.43444 7.17457M1.43444 7.17457C1.59161 6.884 1.78967 6.60604 2.0235 6.35338C2.44517 5.91122 3.02656 5.59542 4.18678 4.96376L6.75 3.56149M18.0328 10.0801L23.5656 7.17457M18.0328 10.0801L6.75 3.56149M18.0328 10.0801V14.666M23.5656 7.17457C23.4045 6.87769 23.2066 6.60181 22.9765 6.35338C22.5548 5.91122 21.9734 5.59542 20.8132 4.96376L15.6868 2.15922C14.5266 1.52756 13.9452 1.19898 13.328 1.08528C12.782 0.971574 12.218 0.971574 11.672 1.08528C11.0548 1.19898 10.4734 1.52756 9.31322 2.15922L6.75 3.56149"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ResourceIconBottomActive = () => {
  return (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.875 6.99976L12.375 12.9998L12.875 24.9998L23.875 18.9998V16.9998V6.99976Z"
        fill="#2F3A79"
        stroke="black"
        stroke-width="0.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.875 7L12.375 13L11.875 25L0.875 19V17V7Z"
        fill="#B5B5B5"
        stroke="black"
        stroke-width="0.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.625 12.9985V25M12.625 12.9985L1.55944 7.17457M12.625 12.9985L18.1578 10.0801M12.625 25C12.9023 25 13.1808 24.9748 13.453 24.9116C14.0702 24.7979 14.6516 24.4693 15.8118 23.8377L20.9382 21.0332C22.0984 20.4015 22.6798 20.0857 23.1015 19.6435C23.4759 19.2393 23.757 18.7845 23.9295 18.2792C24.125 17.7107 24.125 17.0789 24.125 15.803V10.1939C24.125 8.91797 24.125 8.2862 23.9295 7.71771C23.8656 7.52821 23.7851 7.35143 23.6906 7.17457M12.625 25C12.3477 25 12.0692 24.9748 11.797 24.9116C11.1798 24.7979 10.5984 24.4693 9.43822 23.8377L4.31178 21.0332C3.15156 20.4015 2.57017 20.0857 2.1485 19.6435C1.77877 19.2512 1.49665 18.7864 1.3205 18.2792C1.125 17.7107 1.125 17.0789 1.125 15.803V10.1939C1.125 8.91797 1.125 8.2862 1.3205 7.71771C1.38439 7.52821 1.46488 7.35143 1.55944 7.17457M1.55944 7.17457C1.71661 6.884 1.91467 6.60604 2.1485 6.35338C2.57017 5.91122 3.15156 5.59542 4.31178 4.96376L6.875 3.56149M18.1578 10.0801L23.6906 7.17457M18.1578 10.0801L6.875 3.56149M18.1578 10.0801V14.666M23.6906 7.17457C23.5295 6.87769 23.3316 6.60181 23.1015 6.35338C22.6798 5.91122 22.0984 5.59542 20.9382 4.96376L15.8118 2.15922C14.6516 1.52756 14.0702 1.19898 13.453 1.08528C12.907 0.971574 12.343 0.971574 11.797 1.08528C11.1798 1.19898 10.5984 1.52756 9.43822 2.15922L6.875 3.56149"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RolesIconBottom = () => {
  return (
    <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.102 25H3.86689C3.45777 25.0005 3.05256 24.9205 2.67442 24.7646C2.29629 24.6088 1.95265 24.38 1.66316 24.0915C1.37368 23.8029 1.14402 23.4603 0.987332 23.0832C0.830644 22.706 0.75 22.3017 0.75 21.8934C0.75 18.4534 3.54093 15.6667 6.98515 15.6667H10.102M16.7821 6.33333C16.7821 7.74782 16.2191 9.1043 15.2169 10.1045C14.2147 11.1047 12.8554 11.6667 11.4381 11.6667C10.0207 11.6667 8.66145 11.1047 7.65925 10.1045C6.65705 9.1043 6.09403 7.74782 6.09403 6.33333C6.09403 4.91884 6.65705 3.56237 7.65925 2.56217C8.66145 1.56198 10.0207 1 11.4381 1C12.8554 1 14.2147 1.56198 15.2169 2.56217C16.2191 3.56237 16.7821 4.91884 16.7821 6.33333ZM16.0299 21.6913L17.3659 23.4687L17.3692 23.4731C17.9468 24.2421 18.2363 24.6276 18.5924 24.7646C18.9033 24.886 19.2487 24.886 19.5596 24.7646C19.9157 24.6276 20.2052 24.2421 20.7828 23.4731L20.7861 23.4687L22.1221 21.6913C22.4668 21.2327 22.6391 21.0033 22.7059 20.7513C22.7647 20.5284 22.7647 20.2942 22.7059 20.0713C22.6391 19.8193 22.4668 19.5899 22.1221 19.1313L20.7861 17.3539L20.7828 17.3495C20.2051 16.5804 19.9157 16.195 19.5596 16.0579C19.2487 15.9366 18.9033 15.9366 18.5924 16.0579C18.2363 16.195 17.9469 16.5804 17.3692 17.3495L17.3659 17.3539L16.0299 19.1313C15.6852 19.5899 15.5129 19.8193 15.4461 20.0713C15.3873 20.2942 15.3873 20.5284 15.4461 20.7513C15.5129 21.0033 15.6852 21.2327 16.0299 21.6913Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RolesIconBottomActive = () => {
  return (
    <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.3659 23.4687L16.0299 21.6913C15.6852 21.2326 15.5129 21.0033 15.4461 20.7513C15.3873 20.5284 15.3873 20.2942 15.4461 20.0713C15.5129 19.8193 15.6852 19.5899 16.0299 19.1313L17.3659 17.3539L17.3692 17.3495C17.9469 16.5804 18.2363 16.195 18.5924 16.0579C18.9033 15.9366 19.2487 15.9366 19.5596 16.0579C19.9157 16.195 20.2052 16.5804 20.7828 17.3495L20.7861 17.3539L22.1221 19.1313C22.4668 19.5899 22.6391 19.8193 22.7059 20.0713C22.7647 20.2942 22.7647 20.5284 22.7059 20.7513C22.6391 21.0033 22.4668 21.2326 22.1221 21.6913L20.7861 23.4687L20.7828 23.4731C20.2052 24.2421 19.9157 24.6276 19.5596 24.7646C19.2487 24.886 18.9033 24.886 18.5924 24.7646C18.2363 24.6276 17.9469 24.2421 17.3692 23.4731L17.3659 23.4687Z"
        fill="#2F3A79"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.102 25H3.86689C3.45777 25.0005 3.05256 24.9205 2.67442 24.7646C2.29629 24.6088 1.95265 24.38 1.66316 24.0915C1.37368 23.8029 1.14402 23.4603 0.987332 23.0832C0.830644 22.706 0.75 22.3017 0.75 21.8934C0.75 18.4534 3.54093 15.6667 6.98515 15.6667H10.102M16.7821 6.33333C16.7821 7.74782 16.2191 9.1043 15.2169 10.1045C14.2147 11.1047 12.8554 11.6667 11.4381 11.6667C10.0207 11.6667 8.66145 11.1047 7.65925 10.1045C6.65705 9.1043 6.09403 7.74782 6.09403 6.33333C6.09403 4.91884 6.65705 3.56237 7.65925 2.56217C8.66145 1.56198 10.0207 1 11.4381 1C12.8554 1 14.2147 1.56198 15.2169 2.56217C16.2191 3.56237 16.7821 4.91884 16.7821 6.33333ZM16.0299 21.6913L17.3659 23.4687L17.3692 23.4731C17.9468 24.2421 18.2363 24.6276 18.5924 24.7646C18.9033 24.886 19.2487 24.886 19.5596 24.7646C19.9157 24.6276 20.2052 24.2421 20.7828 23.4731L20.7861 23.4687L22.1221 21.6913C22.4668 21.2327 22.6391 21.0033 22.7059 20.7513C22.7647 20.5284 22.7647 20.2942 22.7059 20.0713C22.6391 19.8193 22.4668 19.5899 22.1221 19.1313L20.7861 17.3539L20.7828 17.3495C20.2051 16.5804 19.9157 16.195 19.5596 16.0579C19.2487 15.9366 18.9033 15.9366 18.5924 16.0579C18.2363 16.195 17.9469 16.5804 17.3692 17.3495L17.3659 17.3539L16.0299 19.1313C15.6852 19.5899 15.5129 19.8193 15.4461 20.0713C15.3873 20.2942 15.3873 20.5284 15.4461 20.7513C15.5129 21.0033 15.6852 21.2327 16.0299 21.6913Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BottomActiveBar = () => {
  return (
    <svg width="52" height="3" viewBox="0 0 52 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M49 3C50.6569 3 52 1.65685 52 -2.38419e-06L-1.31134e-07 -1.11194e-07C-5.87108e-08 1.65686 1.34315 3 3 3L49 3Z"
        fill="url(#paint0_linear_5101_18217)"
        fill-opacity="0.6"
      />
      <path
        d="M49 3C50.6569 3 52 1.65685 52 -2.38419e-06L-1.31134e-07 -1.11194e-07C-5.87108e-08 1.65686 1.34315 3 3 3L49 3Z"
        fill="#2F3A79"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5101_18217"
          x1="26"
          y1="3"
          x2="26"
          y2="-1.24769e-06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2F3A79" />
          <stop offset="1" stop-color="#CA373C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const AppTrainingIcon = () => {
  return (
    <svg width="27" height="15" viewBox="0 0 27 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.05083 6.57879C1.28886 4.03288 3.28208 1.97037 5.88417 1.57442C10.9289 0.808526 16.0711 0.808526 21.1158 1.57442C23.7192 1.97037 25.7111 4.03288 25.9492 6.57879C26.2373 9.65422 25.3654 13.1386 21.6508 13.8903C20.8037 14.0604 19.9253 14.032 19.0925 13.8076C18.2598 13.5832 17.498 13.1696 16.8738 12.6032C14.6902 10.6364 12.2221 10.7156 10.1262 12.6032C9.50217 13.1698 8.74038 13.5835 7.90756 13.8079C7.07475 14.0323 6.19632 14.0606 5.34922 13.8903C1.63463 13.1386 0.762679 9.65422 1.05083 6.57879Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ActivateSearchIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 21L14.2778 14.2777M14.2778 14.2777C15.0003 13.5557 15.5734 12.6983 15.9643 11.7545C16.3551 10.8108 16.5561 9.79926 16.5556 8.77778C16.5556 4.47778 13.0733 1 8.77778 1C4.48222 1 1 4.47778 1 8.77778C1 13.0778 4.48222 16.5556 8.77778 16.5556C10.9256 16.5556 12.87 15.6888 14.2778 14.2777Z"
        stroke="#363636"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25 2.65278C6.25 3.12427 6.06563 3.57646 5.73744 3.90986C5.40925 4.24326 4.96413 4.43056 4.5 4.43056C4.03587 4.43056 3.59075 4.24326 3.26256 3.90986C2.93437 3.57646 2.75 3.12427 2.75 2.65278C2.75 2.18128 2.93437 1.7291 3.26256 1.3957C3.59075 1.0623 4.03587 0.875 4.5 0.875C4.96413 0.875 5.40925 1.0623 5.73744 1.3957C6.06563 1.7291 6.25 2.18128 6.25 2.65278ZM2.75 6.20833H6.25C6.71413 6.20833 7.15925 6.39563 7.48744 6.72903C7.81563 7.06243 8 7.51462 8 7.98611C8 8.22186 7.90781 8.44794 7.74372 8.61464C7.57962 8.78134 7.35706 8.875 7.125 8.875H1.875C1.64294 8.875 1.42038 8.78134 1.25628 8.61464C1.09219 8.44794 1 8.22186 1 7.98611C1 7.51462 1.18437 7.06243 1.51256 6.72903C1.84075 6.39563 2.28587 6.20833 2.75 6.20833Z"
        stroke="#2F3A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.66667 16.3333L12.5 12.5M12.5 12.5L16.3333 8.66667M12.5 12.5L8.66667 8.66667M12.5 12.5L16.3333 16.3333M12.5 24C9.45001 24 6.52493 22.7885 4.36826 20.6318C2.21159 18.4751 1 15.55 1 12.5C1 9.45001 2.21159 6.52487 4.36826 4.3682C6.52493 2.21154 9.45001 1 12.5 1C15.55 1 18.4751 2.21154 20.6317 4.3682C22.7884 6.52487 24 9.45001 24 12.5C24 15.55 22.7884 18.4751 20.6317 20.6318C18.4751 22.7885 15.55 24 12.5 24Z"
        stroke="#333333"
        stroke-opacity="0.5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BtnAddIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 16V8.5M8.5 8.5V1M8.5 8.5H1M8.5 8.5H16"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BtnAssignAppIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3333 15.7292V13.3334M13.3333 13.3334V10.9375M13.3333 13.3334H10.9375M13.3333 13.3334H15.7292M1 3.66663C1 2.73329 1 2.26674 1.18167 1.90841C1.34167 1.60007 1.59666 1.34164 1.91 1.18331C2.26666 0.999976 2.73333 1 3.66666 1H4.16667C5.1 1 5.56667 0.999976 5.92334 1.18331C6.23667 1.34164 6.49166 1.60007 6.65166 1.90841C6.83333 2.26674 6.83333 2.73329 6.83333 3.66663V4.16671C6.83333 5.10004 6.83333 5.56659 6.65166 5.92493C6.49166 6.23326 6.23667 6.49169 5.92334 6.65002C5.56667 6.83336 5.1 6.83333 4.16667 6.83333H3.66666C2.73333 6.83333 2.26666 6.83336 1.91 6.65002C1.59666 6.49169 1.34167 6.23326 1.18167 5.92493C1 5.56659 1 5.10004 1 4.16671V3.66663ZM1 12.8333C1 11.9 1 11.4334 1.18167 11.0751C1.34167 10.7667 1.59666 10.5083 1.91 10.35C2.26666 10.1666 2.73333 10.1667 3.66666 10.1667H4.16667C5.1 10.1667 5.56667 10.1666 5.92334 10.35C6.23667 10.5083 6.49166 10.7667 6.65166 11.0751C6.83333 11.4334 6.83333 11.9 6.83333 12.8333V13.3334C6.83333 14.2667 6.83333 14.7333 6.65166 15.0916C6.49166 15.3999 6.23667 15.6584 5.92334 15.8167C5.56667 16 5.1 16 4.16667 16H3.66666C2.73333 16 2.26666 16 1.91 15.8167C1.59666 15.6584 1.34167 15.3999 1.18167 15.0916C1 14.7333 1 14.2667 1 13.3334V12.8333ZM10.1667 3.66663C10.1667 2.73329 10.1667 2.26674 10.3483 1.90841C10.5083 1.60007 10.7633 1.34164 11.0767 1.18331C11.4333 0.999976 11.9 1 12.8333 1H13.3333C14.2667 1 14.7333 0.999976 15.09 1.18331C15.4033 1.34164 15.6583 1.60007 15.8183 1.90841C16 2.26674 16 2.73329 16 3.66663V4.16671C16 5.10004 16 5.56659 15.8183 5.92493C15.6583 6.23326 15.4033 6.49169 15.09 6.65002C14.7333 6.83336 14.2667 6.83333 13.3333 6.83333H12.8333C11.9 6.83333 11.4333 6.83336 11.0767 6.65002C10.7633 6.49169 10.5083 6.23326 10.3483 5.92493C10.1667 5.56659 10.1667 5.10004 10.1667 4.16671V3.66663Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BtnAddUserIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.66667 11H4.33333C3.44928 11 2.60143 11.3512 1.97631 11.9763C1.35119 12.6014 1 13.4493 1 14.3333C1 14.7754 1.17559 15.1993 1.48815 15.5118C1.80071 15.8244 2.22464 16 2.66667 16H11M13.5 13.5V11M13.5 11V8.5M13.5 11H11M13.5 11H16M11 4.33333C11 5.21739 10.6488 6.06524 10.0237 6.69036C9.39857 7.31548 8.55072 7.66667 7.66667 7.66667C6.78261 7.66667 5.93476 7.31548 5.30964 6.69036C4.68452 6.06524 4.33333 5.21739 4.33333 4.33333C4.33333 3.44928 4.68452 2.60143 5.30964 1.97631C5.93476 1.35119 6.78261 1 7.66667 1C8.55072 1 9.39857 1.35119 10.0237 1.97631C10.6488 2.60143 11 3.44928 11 4.33333Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BtnAddGroupIcon = () => {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.70482 4.97006V2.45801C7.70482 1.90572 7.2571 1.45801 6.70482 1.45801H4.35241M7.70482 4.97006H15.3253C15.8776 4.97006 16.3253 5.41777 16.3253 5.97006V10.717M7.70482 4.97006V8.4821M7.70482 4.97006H4.35241M4.35241 1.45801H2C1.44772 1.45801 1 1.90572 1 2.45801V4.97006M4.35241 1.45801V4.97006M4.35241 15.1869H2C1.44772 15.1869 1 14.7392 1 14.1869V11.6749M4.35241 15.1869H7.70482M4.35241 15.1869V11.6749M7.70482 15.1869V11.6749M7.70482 15.1869H12.1747M1 11.6749H4.35241M1 11.6749V8.4821M4.35241 11.6749H7.70482M4.35241 11.6749V8.4821M7.70482 11.6749V8.4821M7.70482 11.6749H10.259M1 8.4821H4.35241M1 8.4821V4.97006M4.35241 8.4821H7.70482M4.35241 8.4821V4.97006M7.70482 8.4821H10.259M4.35241 4.97006H1"
        stroke="white"
      />
      <path d="M13.2713 11.5364V11.8137H12.994V11.5364H13.2713Z" fill="white" stroke="white" />
      <path d="M13.2713 8.34351V8.62085H12.994V8.34351H13.2713Z" fill="white" stroke="white" />
      <path
        d="M16.2189 17.2091V14.7613M16.2189 14.7613V12.3135M16.2189 14.7613H13.7711M16.2189 14.7613H18.6667"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SearchFilterIconMob = () => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 3.4375H6.44444M6.44444 3.4375C6.44444 4.78625 7.489 5.875 8.77778 5.875H9.55556C10.8443 5.875 11.8889 4.78625 11.8889 3.4375C11.8889 2.08875 10.8443 1 9.55556 1H8.77778C7.489 1 6.44444 2.08875 6.44444 3.4375ZM11.1111 11.5625H15M14.2222 3.4375H15M1 11.5625H3.33333M3.33333 11.5625C3.33333 12.9112 4.37789 14 5.66667 14H6.44444C7.73322 14 8.77778 12.9112 8.77778 11.5625C8.77778 10.2138 7.73322 9.125 6.44444 9.125H5.66667C4.37789 9.125 3.33333 10.2138 3.33333 11.5625Z"
        stroke="#363636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};


export const BreadcrumbIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#2F3A79 "
    class="bi bi-caret-right-fill"
    viewBox="0 0 16 16"
  >
    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
  </svg>
);